import { RedirectionTypesEnum } from 'common/enums/ButtonActionEnum'
import React from 'react'
import {
  BasePublisherButton,
  BasePublisherButtonProps,
} from 'src/publisher/entities/base-publisher-button'
import { SuccessButtonTextUi } from 'src/publisher/entities/button-new/components/success-button-text-ui'
import { useThemeColor } from 'src/publisher/shared/hooks/use-theme-color'
import { SendFormActionButtonEntityInterface } from 'src/shared/entities/button/send-form.action-button.schema'

export interface SendFormBasePublisherButtonProps
  extends BasePublisherButtonProps {
  entityOrSubEntity: SendFormActionButtonEntityInterface
  isSuccess: boolean
}

export const SendFormBasePublisherButton = ({
  isSuccess,
  entityOrSubEntity,
  ...rest
}: SendFormBasePublisherButtonProps) => {
  const {
    text: { paragraphTextColor },
  } = useThemeColor()
  return (
    <BasePublisherButton
      entityOrSubEntity={entityOrSubEntity}
      {...rest}
      endElement={
        isSuccess &&
        entityOrSubEntity.redirectionType === RedirectionTypesEnum.none && (
          <SuccessButtonTextUi
            alignSelf={entityOrSubEntity.alignSelf}
            mobileAlignSelf={entityOrSubEntity.mobileAlignSelf}
            textColor={
              entityOrSubEntity.optInSuccessTextColor || paragraphTextColor
            }
          >
            {entityOrSubEntity.optInSuccessText}
          </SuccessButtonTextUi>
        )
      }
    />
  )
}
